import React, { Component } from 'react'
import { connect } from 'react-redux'

import * as R from 'ramda'
import Moment from 'moment'

import Checkbox from 'material-ui/Checkbox'

import dataActions from 'actions/dataActions'
import { doc, dirtyRead } from 'selectors/common'

let select = dirtyRead(
	(state, props) => ({
		transaction: doc(state, props.objectID)
	})
)

export class CheckBoxIsPaid extends Component{
	render(){
		let { props } = this
		return(
			<Checkbox
				onClick={() => {props.EDIT('transaction/bill')}}
				label="Is paid"
				checked={props.transaction.isPaid && props.transaction.isPaid.toString() == "true"}
				style={{display: (props.transaction.qbid || props.transaction.paymentMethod=="QuickBooks") ? "none":"block"}}
				disabled={props.transaction.qbid || props.transaction.qbidNew}
				iconStyle={{
					color: "#00d4b3"
					, fill: "#00d4b3"
					, marginRight: "17px"
				}}
				onCheck={()=>{
					if (!props.transaction.qbid)
						props.STAGE({
						  _id: props.objectID
						, isPaid: props.transaction.isPaid && props.transaction.isPaid.toString() == "true" ? "false" : "true"
					})
				}}
			/>
		)
	}
}

export default connect(select, dataActions)(CheckBoxIsPaid)



// WEBPACK FOOTER //
// ./src/routes/landlord/transactionForm/CheckBoxIsPaid.js